import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, mapTo, startWith, switchMap } from 'rxjs/operators';
import { AbstractNotificationTemplateApiService } from 'src/app/core/services/abstract/abstract-notification-template-api-service';
import * as actions from './actions';

@Injectable()
export class NotificationTemplateStoreEffects {
  private notificationTemplateApiService = inject(AbstractNotificationTemplateApiService);
  private actions$ = inject(Actions);

  loadRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.LoadRequestAction>(actions.ActionTypes.LOAD_REQUEST),
      switchMap(action =>
        this.notificationTemplateApiService.getAllNotificationTemplates().pipe(
          map(items => (items.isSucceeded ? new actions.LoadSuccessAction(items.result) : new actions.FailureAction(items.errors[0]))),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  setSelectedRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.SetSelectedRequestAction>(actions.ActionTypes.SET_SELECTED_REQUEST),
      switchMap(action =>
        this.notificationTemplateApiService.getNotificationTemplateById(action.id).pipe(
          map(items =>
            items.isSucceeded ? new actions.SetSelectedSuccessAction(items.result) : new actions.FailureAction(items.errors[0])
          ),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  saveRequesEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.SaveRequestAction>(actions.ActionTypes.SAVE_REQUEST),
      switchMap(action =>
        this.notificationTemplateApiService.saveNotificationTemplate(action.template).pipe(
          map(items => (items.isSucceeded ? new actions.SaveSuccessAction(items.result) : new actions.FailureAction(items.errors[0]))),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  loadParametersRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.LoadParametersRequestAction>(actions.ActionTypes.LOAD_PARAMETERS_REQUEST),
      switchMap(action =>
        this.notificationTemplateApiService.getParameters().pipe(
          map(items =>
            items.isSucceeded ? new actions.LoadParametersSuccessAction(items.result) : new actions.FailureAction(items.errors[0])
          ),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );
}
